import * as types from "./types"

export function getGlobalConfigurationData() {
    return {
        type: types.GET_GLOBAL_CONFIG_DATA,
    }
}

export function setGlobalConfigurationData(config = {}) {
    return {
        type: types.SET_GLOBAL_CONFIG_DATA,
        payload: config,
    }
}

export function getGlobalConfigurationDataFailed(error = {}) {
    return {
        type: types.GET_GLOBAL_CONFIG_DATA_FAILED,
        payload: error,
    }
}
